import { useFormikContext } from "formik";
import { useEffect, useRef } from "react";

function getFirstErrorKey(obj: any, prefix = ""): string | null {
  if (!obj || typeof obj !== "object") {
    return null;
  }

  const keys = Object.keys(obj);

  for (const key of keys) {
    const value = obj[key];
    const currentKey = prefix ? `${prefix}.${key}` : key;

    if (typeof value === "string" && value) {
      return currentKey;
    }

    if (typeof value === "object" && value !== null) {
      const nestedKey = getFirstErrorKey(value, currentKey);

      if (nestedKey) {
        return nestedKey;
      }
    }
  }

  return null;
}

export const ScrollToError = () => {
  const { errors, submitCount, isValid } = useFormikContext();
  const submitCountRef = useRef(submitCount);

  useEffect(() => {
    if (submitCount > submitCountRef.current) {
      if (!isValid) {
        const firstErrorKey = getFirstErrorKey(errors);

        if (firstErrorKey) {
          const element = document.querySelector(
            `[data-form-control-name="${firstErrorKey}"]`
          );

          if (element) {
            element.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        }
      }
    }

    submitCountRef.current = submitCount;
  }, [errors, submitCount, isValid]);

  return null;
};
